/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */
import Message, { IMessage } from './../../message';
import { IDescriptorBody } from '../../descriptor';

export interface IGetUserResponse extends IMessage {
	attributes: Record<string, string>[];
}

export default class GetUserResponse extends Message {
	public static readonly DESCRIPTOR_NAME: string = 'GetUserResponse';

	public static readonly DESCRIPTOR: IDescriptorBody = {
		fields: {
			attributes: {
				rule: 'repeated',
				type: 'KeyValueDescriptor',
				id: 1
			}
		}
	};

	public constructor( public readonly attributes: Record<string, unknown> ) {
		super();
	}

	public toJSON(): IGetUserResponse {
		return {
			attributes: Object.keys( this.attributes ).map( key => ( { key, value: JSON.stringify( this.attributes[ key ] ) } ) )
		};
	}

	public static fromJSON( data: IGetUserResponse ): GetUserResponse {
		const attributes: Record<string, string> = data.attributes.reduce(
			( result, keyValue ) => {
				result[ keyValue.key ] = keyValue.value ? JSON.parse( keyValue.value ) : null;

				return result;
			},
			{}
		);

		return new GetUserResponse( attributes );
	}
}
